import * as busyIndicator from "client_legacy/ndaw/busyIndicator";
import { DocumentItemViewModel, RecentDocumentItemViewModel } from "client/Api/Documents/SharePoint/common";
import { convertToLocationModel } from "../listLocationModelProvider";
import { itemLocationUrl } from "client/Api/Documents/SharePoint/sharepointDocuments";
import { navigateTo } from "client_legacy/ndaw/navigator";
import { ContainerType } from "client_legacy/ndaw/busyIndicator";

export async function execute(
	document: DocumentItemViewModel | RecentDocumentItemViewModel,
	openInNewWindow: boolean = false
): Promise<void> {
	const busyIndicatorTarget: ContainerType = "#main-content";

	busyIndicator.show(busyIndicatorTarget);

	try {
		const url: string = await itemLocationUrl(
			document.id,
			convertToLocationModel(document.location)
		);

		navigateTo(url, openInNewWindow);
	} finally {
		busyIndicator.hide(busyIndicatorTarget);
	}
}
